/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { PLANOGRAM_CHANGE_DETAILS_FRAGMENT } from '../fragments/PlanogramChangeDetailsFragment'

export const GET_DISPLAY_PLANOGRAM_HISTORY = gql`
  query GetDisplayPlanogramHistory(
    $displayId: ID!
    $pagination: OffsetLimitPaginationFilter
  ) {
    displayPlanogramHistoryCount(displayId: $displayId)
    displayPlanogramHistory(displayId: $displayId, pagination: $pagination) {
      ...PlanogramChangeDetails
    }
  }
  ${PLANOGRAM_CHANGE_DETAILS_FRAGMENT}
`
